import { all, not, equals } from 'ramda'

import appSelectors from 'App/duck/selectors'

const getInboxState = (state): any => state.account.inbox

const getShouldShowInbox = (state): any =>
  appSelectors.getIsPayLaterActivatedForUser(state) &&
  appSelectors.getIsPayLaterPostPurchaseEnabled(state) &&
  appSelectors.getShowAlerts(state)

const getMessagesIsLoading = (state): any => getInboxState(state).isLoading

const getMessagesHasLoaded = (state): any => getInboxState(state).hasLoaded

const getIsOpen = (state): any => getInboxState(state).isOpen

const getMessages = (state): any => getInboxState(state).messages

const getMessagesError = (state): any => getInboxState(state).error

const getAreAllMessagesRead = (state): any => getMessages(state).every((message) => message.read)

const getShouldFetchMessages = (state): any =>
  all(equals(true))([
    not(getMessagesIsLoading(state)),
    not(getMessagesHasLoaded(state)),
    appSelectors.getIsPayLaterActivatedForUser(state),
  ])

export default {
  getMessagesIsLoading,
  getMessagesHasLoaded,
  getIsOpen,
  getMessages,
  getMessagesError,
  getAreAllMessagesRead,
  getShouldFetchMessages,
  getShouldShowInbox,
}
